const NumberFormattingEnum = Object.freeze({
  CURRENCY: 'currency',
  NUMBER: 'number'
})

export default NumberFormattingEnum
